import React from 'react'
import './message.scss';
import { Speaker } from '../models/enum';
import Brand from '../brand/Brand';
import { isValidURL } from '../util/validators';

const LiveChatMessage = ({liveChatMessage}: any) => {
    const garnishResponse = (responseText: string) => {
        if (isValidURL(responseText)) {
            let link = (responseText.indexOf('https://') === 0 || responseText.indexOf('http://') === 0) ?
                responseText : `http://${responseText}`;
            return <a className="message__text--link" href={link} target="_blank" rel="noopener noreferrer">{responseText}</a>
        } else {
            return responseText;
        }
    }


    return (
        <div className="livechat">
            <div className="livechat__message">
                {
                    liveChatMessage.from === Speaker.System &&
                    <div className="livechat__message--system">
                        {liveChatMessage.text}
                    </div>
                }
                {
                    liveChatMessage.from === Speaker.Agent &&
                    <div className="livechat__message--agent">
                        <div className="livechat__message--agent-profile">
                            <img src="/images/chatbot-agent-profile.png" alt="Murphy"
                            className="brand__logo" />
                        </div>
                        <div className="livechat__message--agent-text"> 
                            <div className="message__text">
                                {garnishResponse(liveChatMessage.text)}
                            </div>
                        </div>
                    </div>
                }

                {
                    liveChatMessage.from === Speaker.Murphy &&
                    <div className="livechat__message--agent">
                        <div className="message__brand">
                            <Brand size='small' />
                        </div>
                        <div className="livechat__message--agent-text"> 
                            <div className="message__text">
                                    {liveChatMessage.text}
                            </div>
                        </div>
                    </div>
                }

                {
                    liveChatMessage.from === Speaker.User &&
                    <div className="livechat__message--right">
                        <div className="message__text">
                                {liveChatMessage.text}
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default LiveChatMessage
